/* =====================
   Ajoutez ici votre propre javascript personnalisé
   ===================== */


/* SOS Serrurier Agde — mesure limitée aux visiteurs ayant consenti. */
(() => {
  'use strict';
  const id = 'G-E6F30JK5ZK';
  if (window.__sosAnalyticsInstalled || window.Shopify?.designMode) return;
  window.__sosAnalyticsInstalled = true;
  let started = false;
  let enabled = false;
  const pendingKey = 'sos_quote_pending_v1';
  function allowed() {
    try {
      const privacy = window.Shopify?.customerPrivacy;
      return privacy?.analyticsProcessingAllowed() === true &&
        privacy.currentVisitorConsent().analytics === 'yes';
    } catch (_) { return false; }
  }
  function pageLocation() {
    const clean = new URL(location.origin + location.pathname);
    const source = new URLSearchParams(location.search);
    ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content'].forEach(key => {
      const value = source.get(key);
      if (value && /^[a-z0-9_-]{1,60}$/i.test(value)) clean.searchParams.set(key, value);
    });
    return clean.href;
  }
  function referrer() {
    try { return document.referrer ? new URL(document.referrer).origin + '/' : ''; }
    catch (_) { return ''; }
  }
  function event(name, extra = {}) {
    if (!started || !enabled || !allowed()) return;
    window.gtag('event', name, {
      send_to: id, page_location: pageLocation(), page_title: document.title,
      page_referrer: referrer(), ...extra
    });
  }
  function successfulQuote() {
    if (!document.querySelector('.sq-form .sq-success') || !allowed()) return;
    try {
      const submittedAt = Number(sessionStorage.getItem(pendingKey));
      sessionStorage.removeItem(pendingKey);
      if (submittedAt > 0 && Date.now() - submittedAt >= 0 && Date.now() - submittedAt < 1800000) {
        event('generate_lead', {form_name: 'demande_devis', lead_type: 'devis_envoye'});
      }
    } catch (_) { /* Le formulaire reste fonctionnel sans stockage. */ }
  }
  function syncConsent() {
    enabled = allowed();
    window['ga-disable-' + id] = !enabled;
    if (!enabled) {
      if (started) window.gtag('consent', 'update', {analytics_storage: 'denied'});
      try { sessionStorage.removeItem(pendingKey); } catch (_) {}
      return;
    }
    if (started) {
      window.gtag('consent', 'update', {analytics_storage: 'granted'});
      return;
    }
    started = true;
    window.dataLayer = window.dataLayer || [];
    window.gtag = window.gtag || function () { window.dataLayer.push(arguments); };
    window.gtag('consent', 'default', {
      analytics_storage: 'granted', ad_storage: 'denied',
      ad_user_data: 'denied', ad_personalization: 'denied'
    });
    window.gtag('js', new Date());
    window.gtag('config', id, {
      send_page_view: false, allow_google_signals: false,
      allow_ad_personalization_signals: false, cookie_expires: 34128000,
      cookie_update: false, page_location: pageLocation(), page_referrer: referrer()
    });
    const script = document.createElement('script');
    script.async = true;
    script.src = 'https://www.googletagmanager.com/gtag/js?id=' + id;
    document.head.appendChild(script);
    event('page_view');
    successfulQuote();
  }
  document.addEventListener('visitorConsentCollected', syncConsent);
  document.addEventListener('click', e => {
    const link = e.target instanceof Element ? e.target.closest('a[href^="tel:"]') : null;
    if (link) event('click_to_call', {contact_method: 'telephone'});
  }, true);
  document.addEventListener('submit', e => {
    if (!e.target.matches('.sq-form') || !allowed() || !e.target.checkValidity()) return;
    try { sessionStorage.setItem(pendingKey, String(Date.now())); } catch (_) {}
  }, true);
  function init() {
    const footer = document.querySelector('.footer-copyright') || document.querySelector('footer');
    if (footer && !document.querySelector('[data-sos-cookie-preferences]')) {
      const button = document.createElement('button');
      button.type = 'button';
      button.textContent = 'Préférences cookies';
      button.dataset.sosCookiePreferences = '';
      button.style.cssText = 'display:block;margin:12px auto;padding:8px 12px;border:1px solid currentColor;border-radius:6px;background:transparent;color:inherit;font:inherit;cursor:pointer;font-size:12px';
      button.addEventListener('click', () => {
        if (window.Shopify?.privacyBanner?.showPreferences) window.Shopify.privacyBanner.showPreferences();
        else if (window.privacyBanner?.showPreferences) window.privacyBanner.showPreferences();
      });
      footer.appendChild(button);
    }
    if (window.Shopify?.customerPrivacy) syncConsent();
    else if (window.Shopify?.loadFeatures) {
      window.Shopify.loadFeatures([{name: 'consent-tracking-api', version: '0.2'}], error => {
        if (!error) syncConsent();
      });
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, {once: true});
  else init();
})();
